import PropTypes from 'prop-types';
import React from 'react';
import { kebabCase } from 'lodash';
import dateFormatConstant from '../../../constants/dateFormatConstant';
import { enabledSelector, labelSelector, newPathSelector, valueSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import DateTimePicker from '../../common/controls/dateTimePicker';
import Label from './label';
import logValueOnChange from '../commonActions/logValueOnChange';
import localChangeSelector from '../selectors/localChangeSelector';
import customerConfigurationSelector from '../selectors/customerDateFormatSelector';
const DatePickerField = _ref => {
  let enabled = _ref.enabled,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    _ref$testingIdentifie = _ref.testingIdentifier,
    testingIdentifier = _ref$testingIdentifie === void 0 ? 'default-id' : _ref$testingIdentifie,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value,
    onChange = _ref.onChange,
    path = _ref.path,
    localChangeFunc = _ref.localChangeFunc,
    _ref$customerDateForm = _ref.customerDateFormat,
    customerDateFormat = _ref$customerDateForm === void 0 ? 'month-first' : _ref$customerDateForm;
  const dateFormat = dateFormatConstant[customerDateFormat];
  const handleChange = async updateValue => {
    if (updateValue !== value) {
      const d = new Date(updateValue);
      const log = {
        path,
        value: updateValue,
        displayValue: d.toDateString()
      };
      await onChange(localChangeFunc(log));
    }
  };

  /**
   * Handle when picker opens with no value - set default to today's date at current time in UTC
   * (i.e., uses now.toISOString(), which returns the current date and time in UTC)
   */
  const handleOpen = () => {
    if (value === null || value === undefined) {
      // Get current time and represent it as a UTC ISO string
      const now = new Date();
      const currentDateTime = now.toISOString();
      handleChange(currentDateTime);
    }
  };
  const id = "dpf-".concat(kebabCase(label));
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": id
  }, /*#__PURE__*/React.createElement(Label, {
    value: label
  }), /*#__PURE__*/React.createElement(DateTimePicker, {
    disabled: !enabled,
    onChange: handleChange,
    value: value,
    onOpen: handleOpen,
    className: "".concat(kebabCase(testingIdentifier), " tqc-date-picker-field"),
    verticalPadding: false,
    dateFormat: dateFormat
  }));
};
DatePickerField.propTypes = {
  enabled: PropTypes.bool.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  testingIdentifier: PropTypes.string,
  value: PropTypes.string,
  path: PropTypes.string.isRequired,
  localChangeFunc: PropTypes.func.isRequired,
  customerDateFormat: PropTypes.string
};
export { DatePickerField as UncomposedDatePickerField };
export default entityComposition(DatePickerField, [], {
  customerDateFormat: customerConfigurationSelector,
  enabled: enabledSelector,
  label: labelSelector,
  value: valueSelector,
  onChange: logValueOnChange,
  path: newPathSelector,
  localChangeFunc: localChangeSelector
});